import styles from './TestimonialSolo.module.scss';

import { Colors } from '../../../theme';
import { Avatar } from '../../display/Avatar';
import { BackgroundColors, remapDeprecatedColors } from './TestimonialMapping';
import { LegacyColorMap } from '@/theme/LegacyColorMap';

export type Props = {
  /**
   * Text content displayed on the top or below the avatar.
   */
  quote: React.ReactNode;
  /**
   * Author name. Text content displayed below quote.
   */
  author: string;
  /**
   * Author avatar url.
   */
  avatarUrl?: string;
  /**
   * Whether or not `TestimonialSolo` has author avatar.
   */
  hasAuthorAvatar?: boolean;
  /**
   * Text content displayed below author initials.
   */
  company: string;
  /**
   * Controls the background of the entire element.
   *
   * Must be one of type `'lava10' | 'ocean10' | 'sun10' | 'white' | 'cream' | 'neutral100' | 'acidWash' | 'neutral200'.
   */
  backgroundColor?: BackgroundColors;
};

/**
 * `TestimonialSolo` is used to add testimonials from happy customers to our landing pages. It features a quote text, an author initials, company and avatar.
 */

export const TestimonialSolo = ({
  backgroundColor,
  avatarUrl,
  hasAuthorAvatar = true,
  quote,
  author,
  company,
}: Props) => {
  return (
    <div
      className={styles.root}
      style={{
        '--_zds-testimonialsolo-background-color':
          Colors[
            LegacyColorMap[
              remapDeprecatedColors(backgroundColor || 'neutral100')
            ]
          ],
      }}
      data-zds
    >
      <div className={styles.content} data-zds>
        {hasAuthorAvatar && (
          <div className={styles.avatarContainer} data-zds>
            <Avatar
              data-testId="Avatar"
              name={author}
              url={avatarUrl}
              size="medium"
            />
          </div>
        )}
        <div className={styles.quote} data-zds>
          {quote}
        </div>
        <p className={styles.author} data-zds>
          {author}
        </p>
        <p className={styles.company} data-zds>
          {company}
        </p>
      </div>
    </div>
  );
};
